// intro/welcome step
import { useStateValue } from '../../../../../../context/AppContext';
import moment from 'moment';
import ErrorPage from '../../../../../nonDigital/error/ErrorPage';
import { createCleanMarkup } from '../../../../../../utils/common';
import { isInSchoolAPEvent, isInSchoolAPHybridEvent } from '../../../../../../utils/event';
import { hasAdminAccess } from '../../../../../../utils/user';
import ToggleCoordinatorTools from '../../../../common/ToggleCoordinatorTools';
import StepContentPanel from '../../../../common/StepContentPanel';
import { Link } from 'react-router-dom';
import Staff from '../../../../common/rooms/details/Setup/Staff';
import React from 'react';
import { CmsContent } from '../../../../common/proctorStepsTypes';
import { Room } from '../../../../../../types/Rooms';
import { useShowPreviewModal } from '../../../../common/rooms/details/Setup/useShowPreviewModal';

// eslint-disable-next-line
const EventStartEndDate = ({ eventStartDt, eventEndDt }: any) => {
  if (eventStartDt === eventEndDt) {
    return (
      <div className='mt-4'>
        <strong>
          {moment(eventStartDt || undefined)
            .local()
            .format('LL')}
        </strong>
      </div>
    );
  }
  return null;
};

interface WelcomePageProps {
  room: Room;
  cmsContent?: CmsContent;
  // eslint-disable-next-line
  user: any;
  // eslint-disable-next-line
  studentStatuses: any;
  stepNum: number;
  introStep: number;
}
export const WelcomePage: React.FC<WelcomePageProps> = ({
  cmsContent,
  user,
  room,
  studentStatuses,
  stepNum,
  introStep,
}) => {
  const { orgEvent } = useStateValue();
  useShowPreviewModal({ user, stepNum, introStep });

  if (!cmsContent) {
    return (
      <div className='container'>
        <ErrorPage errorCode='cms_missing' />
      </div>
    );
  }
  const welcomeContent = cmsContent?.steps?.find((n) => n.step_number === 0);
  const welcomeText = <div dangerouslySetInnerHTML={createCleanMarkup(welcomeContent?.main_panel_content)} />;
  const content = { main_panel_content: welcomeText, main_panel_header: welcomeContent?.main_panel_header };

  let lastAttendanceStepNum = 9;
  if (isInSchoolAPEvent(orgEvent)) {
    lastAttendanceStepNum = 8;
  } else if (isInSchoolAPHybridEvent(orgEvent)) {
    lastAttendanceStepNum = 11;
  }
  return (
    <div>
      {hasAdminAccess(user.rid, user.role) ? (
        <ToggleCoordinatorTools
          options={[
            { 'path': `/rooms/edit/${room?.id}`, 'data-automation': 'coord-link-edit-room', 'label': 'Edit Room' },
            {
              'path': `/rooms/get/${room?.id}/flow/attendance/step/1`,
              'data-automation': 'coord-link-take-attend',
              'label': 'Take Attendance',
            },
            {
              'path': `/rooms/get/${room?.id}/flow/attendance/step/${lastAttendanceStepNum}`,
              'data-automation': 'coord-link-start-test',
              'label': 'Start Test',
            },
            {
              'path': `/rooms/get/${room?.id}/flow/monitor/step/1`,
              'data-automation': 'coord-link-monitor-test',
              'label': 'Monitor Testing',
            },
          ]}
        />
      ) : null}
      <StepContentPanel
        heading='Welcome'
        content={content}
        desc={
          <>
            <div>{welcomeText}</div>
            <div className='wizard-panel-getStarted-Link mt-4'>
              <Link
                data-automation='coord-getStarted-Link'
                className='cb-palette-blue5'
                to={`/rooms/get/${room?.id}/flow/setup/step/1`}
              >
                Get Started
              </Link>
            </div>
          </>
        }
        room={room}
      >
        <div className='text-center'>
          <div style={{ fontSize: '32px', lineHeight: '40px' }} role='heading' aria-level={2}>
            {room?.title}
          </div>
          <div style={{ fontSize: '26px', lineHeight: '32px' }} className='mt-2'>
            {orgEvent.eventTitle}
          </div>

          <EventStartEndDate eventStartDt={orgEvent.eventStartDt} eventEndDt={orgEvent.eventEndDt} />
        </div>
        <hr />
        <div style={{ lineHeight: '35px' }}>
          <div>
            {' '}
            <span>
              <strong>Capacity:</strong>
            </span>{' '}
            <span>
              {room?.capacity} ({studentStatuses.preRosteredStudents.length} students assigned)
            </span>
          </div>
          <div>
            {' '}
            <span>
              <strong>Staff:</strong>
            </span>{' '}
            <Staff room={room} />
          </div>
        </div>
      </StepContentPanel>
    </div>
  );
};
